var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boon-input-container half"},[_c('input',{ref:"input",class:['boon-input', { 'boon-input-filled': !!_vm.value }],attrs:{"type":_vm.type,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"change":_vm.updateValue,"blur":_vm.onBlur}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"focus-border"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cab6f82e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/inputField.vue
// module id = 1375
// module chunks = 1